import {mergeTo} from '#core/utils/config-utils.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';
import {Skeleton} from '#core/application/modules/skeleton/index.js';

import {SportsContent} from '../sports-content.js';

import {homePageFactory} from './home-page.factory';

import PALETTE_SCHEMA from './home.page.palette-schema.yaml';
import SCHEMA from './home-page.schema.yaml';

class HomePageFeature extends AbstractVisualFeature {
    get name() {
        return 'Home Page';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return mergeTo(homePageFactory(PALETTE), {
            TopSports: {
                eventCounter: {
                    headerTotal: this.config.showHeaderTotalEventCount,
                    headerPerSport: this.config.showEventCountPerSport,
                },
            },
            HomePage: {
                layoutParts: {
                    Search: {
                        _mobile_show: this.config.showMobileSearch,
                    },
                    NextRaces: {
                        position: this.config.positionOfNextRaces,
                    },
                    CmsCouponsList: {
                        show: this.config.showCmsCouponsList,
                    },
                },
                topLinkPromotions: {
                    skeletonLoader: {
                        disableLoader: !Skeleton.showOnHomePage,
                    },
                },
                topBannerPromotions: {
                    view: {
                        skeletonLoader: {
                            disableLoader: !Skeleton.showOnHomePage,
                        },
                    },
                },
                eventCardsCarousel: {
                    skeletonLoader: {
                        disableLoader: !Skeleton.showOnHomePage,
                    },
                },
                leftContextMenu: {
                    rowLinkMenu: {
                        skeletonLoader: {
                            disableLoader: !Skeleton.showOnHomePage,
                        },
                    },
                },
                prebuiltPromotionCards: {
                    prebuiltBets: {
                        skeletonLoader: {
                            disableLoader: !Skeleton.showOnHomePage,
                        },
                    },
                },
                nextRacesController: {
                    view: {
                        skeletonLoader: {
                            disableLoader: !Skeleton.showOnHomePage,
                        },
                    },
                },
                topSportCoupons: {
                    primary: {
                        coupon: {
                            view: {
                                maxNumberOfSports: this.config.maxNumberOfLiveSports,
                            },
                            skeletonLoader: {
                                disableLoader: !Skeleton.showOnHomePage,
                            },
                        },
                    },
                    secondary: {
                        coupon: {
                            view: {
                                maxNumberOfSports: this.config.maxNumberOfHighlightedSports,
                            },
                            skeletonLoader: {
                                disableLoader: !Skeleton.showOnHomePage,
                            },
                        },
                    },
                },
            },
        });
    }

    get configSchema() {
        return SCHEMA;
    }
}
new HomePageFeature(SportsContent);
